import { ContactPage } from './contact.component';
import { connect } from 'react-redux';
import { contactCreate } from './../../api/contact/contactAction';

const mapDispatchToProps = {
    contactCreate
};

const mapStateToProps = state => ({
    isLoading: state.contactPage.isLoading,
    isSaved: state.contactPage.isSaved
});

export const ContactContainer = connect(mapStateToProps, mapDispatchToProps)(ContactPage);